export const LogoFull = () => (
  <img src="/logo.svg" alt="Developer Portal" style={{ height: 30, width: 'auto' }} />
);
